import { render, staticRenderFns } from "./ViewNewComponent.vue?vue&type=template&id=41246398&scoped=true"
import script from "./ViewNewComponent.vue?vue&type=script&lang=js"
export * from "./ViewNewComponent.vue?vue&type=script&lang=js"
import style0 from "./ViewNewComponent.vue?vue&type=style&index=0&id=41246398&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41246398",
  null
  
)

export default component.exports